import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import MainSection from "./components/MainSection";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import EULA from "./components/EULA";
import ScrollToTop from "./components/ScrollToTop"; 
import NotFound from "./components/NotFound";
import "./App.css";

// Layout Component for Pages with Header & Footer
const Layout = ({ language, setLanguage }) => {
  const location = useLocation();

  return (
    <div className="App">
      <Header language={language} setLanguage={setLanguage} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/maqs/english" replace />} />
        <Route path="/maqs/english" element={<MainSection language="English" />} />
        <Route path="/maqs/hindi" element={<MainSection language="Hindi" />} />
        <Route path="/maqs/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/maqs/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/maqs/eula" element={<EULA />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

// APK Download Component (No Header/Footer)
const APKDownload = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const apkUrl =
      "https://play.google.com/store/apps/details?id=com.maquickscanner";
    
    // Start APK download
    window.location.href = apkUrl;

    // Redirect to /maqs/english after 3 seconds
    setTimeout(() => {
      navigate("/maqs/english", { replace: true });
    }, 3000);
  }, [navigate]);

  return <p>Downloading APK... You will be redirected shortly.</p>;
};

const App = () => {
  const [language, setLanguage] = useState(localStorage.getItem("language") || "English");

  // Persist language selection
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  return (
    <Router>
      <Routes>
        <Route path="/maqs/" element={<APKDownload />} />
        <Route path="/*" element={<Layout language={language} setLanguage={setLanguage} />} />
      </Routes>
    </Router>
  );
};

export default App;